import { jsx as _jsx } from "react/jsx-runtime";
import SkeletonDataGrid from '../../../components/SkeletonDataGrid';
function CorpMerchantCodesLoading() {
    return (_jsx(SkeletonDataGrid, { columns: [
            { field: 'merchantCodeLinkedStatus', headerName: '', flex: 1 },
            { field: 'merchantCode', headerName: 'Code', flex: 2 },
            { field: 'merchantCodeDescription', headerName: 'Description', flex: 20 },
            { field: 'merchantCodeGroup', headerName: 'Group', flex: 8 },
            { field: 'merchantCodeAction', headerName: '', flex: 3 }
        ], rows: [], skeletonRows: 5, sx: {
            width: '100%',
            '& .MuiDataGrid-virtualScroller': {
                overflow: 'hidden'
            }
        }, autoHeight: true, loading: true }));
}
export default CorpMerchantCodesLoading;
